import { gql } from '@edreamsodigeo/frontend-api-client';

export const GET_USER_QUERY = gql`
  query getUserQuery {
    getUser {
      email
      membership {
        name
      }
    }
  }
`;
